<template lang="html">
  <div class="content-height-xxs xs:content-height-lg flex flex-col bg-lightpurple-mobile md:bg-lightpurple-ipad lg:bg-lightpurple relative">
    <div class="h-full w-full flex flex-col overflow-y-auto">
      <div class="flex md:hidden">
        <img :src="require('images/contact_backgroundMobile.png')" alt="" class="w-full object-cover">
      </div>
      <div class="h-full container-lg mx-auto flex flex-col">
        <div class="h-auto md:h-full">
          <div class="h-auto md:h-full flex flex-row flex-wrap">
            <div class="w-full md:w-1/4 lg:w-1/5 h-auto md:h-full">
              <div class="pt-0 md:pt-16">
                <div class="mt-0 md:mt-3 mx-0 md:mx-4 flex flex-row md:flex-col flex-wrap justify-around md:justify-start">
                  <div v-for="(tab, index) in tabs" :key="tab.name" class="flex flex-row justify-start items-center cursor-pointer px-1 xs:px-0 md:px-10 py-0 md:py-6" @click="selectTab(tab.component)">
                    <span class="text-xs xs:text-lg sm:text-xl font-semibold" :class="selected_tab==tab.component ? 'text-rspurple' : 'text-slategrey'">{{ tab.name}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full md:w-2/5 lg:w-1/3 h-auto md:h-full">
              <div class="h-auto md:h-full py-8">
                <component :is="selected_tab" :key="this.selected_tab"></component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="absolute right-0 bottom-0 hidden md:block lg:hidden">
      <img :src="require('images/Contact_hand.svg')" alt="" class="wd-390">
    </div>
  </div>
</template>

<script>

import BookDemo from "./book_demo.vue";
import Careers from "./careers.vue";
import InvestorRelations from "./investor_relations.vue";
import ContactUs from "./contact_us.vue";

export default {
  components: {
    BookDemo,
    Careers,
    InvestorRelations,
    ContactUs,
  },
  props: {
  },
  data: function() {
    return {
      selected_tab: "BookDemo",
      tabs: [{ name: "Book a Demo", component: "BookDemo"}, { name: "Careers", component: "Careers"}, { name: "Investor Relations", component: "InvestorRelations"}, { name: "Contact Us", component: "ContactUs"}],
    }
  },
  mounted: function() {
  },
  methods: {
    selectTab(tab) {
      this.selected_tab = tab
    },
  }
}
</script>

<style lang="scss">
@responsive {
  .bg-lightpurple {
    background-image: url('~images/contact_background.svg');
    background-position: right;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #f4f3fa;
  }
  .bg-lightpurple-ipad {
    background-image: url('~images/contact_background_ipad.svg');
    background-position: right;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #f4f3fa;
  }
  .bg-lightpurple-mobile {
    background: #f4f3fa;
  }
  .wd-390 {
    width: 390px;
  }
}
</style>
